<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><span class="txit">To my son, Austin. The only person who understands my love of football because he just may love it a little more. Roll Tide, son.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?6ce16500